<template>
    
</template>

<script>
import auth from "@/auth"

export default {
    data:()=>{return {

    }},
    beforeCreate(){
        if(!auth.loggedIn())
           this.$store.commit('setLayout', "login")
        }
    }

</script>

<style>

</style>
